"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var mapping = {
    channel_id: 'channel.id',
    category_id: 'category.id',
    opponent_id: 'opponent.id',
    team_id: 'team.id',
    date: 'date.date',
    description: 'description',
};
function initModel(user, channel) {
    return {
        id: null,
        external_id: '',
        user_id: user.id,
        category_id: '',
        channel_id: channel.id,
        description: '',
        hidden: 0,
        playlists: [],
        plans: [],
        title: '',
        team_id: null,
        opponent_id: null,
        team_score: null,
        opponent_score: null,
        date: '',
        match_location: '',
        thumbnail: '',
        status: '',
        type: 'vod',
        published_at: null,
        hash: '',
        slug: '',
        options: {
            comments: true,
        },
    };
}
function params(id, channel) {
    if (id) {
        return {
            id: id,
            resource: 'VideoFull',
            details: true,
            tags: true,
            include_hash: true,
            channel_id: channel.id,
        };
    }
    return {};
}
var Save = function (_a) {
    var user = _a.user, channel = _a.channel, id = _a.id;
    var _b = react_1.useState(false), changed = _b[0], setChanged = _b[1];
    var _c = storybook_1.Hooks.useModal(), Modal = _c[0], setModal = _c[1], closeModal = _c[2];
    var _d = react_1.useState({}), upload = _d[0], setUpload = _d[1];
    var categories = ra_fetch_1.useApi('backend').index('categories')[0];
    var _e = ra_fetch_1.useApi('backend')
        .mapping(mapping)
        .update('videos', initModel(user, channel), params(id, channel)), video = _e[0], setVideo = _e[1], submitVideo = _e[2];
    react_1.useEffect(function () {
        if (upload.id) {
            setVideo({
                id: upload.id,
                external_id: upload.external_id,
                title: video.data.title || upload.title,
            });
        }
    }, [upload]);
    function toggleVideoOption(field) {
        var _a;
        var options = __assign(__assign({}, video.data.options), (_a = {}, _a[field] = !video.data.options[field], _a));
        setVideo({ options: options });
        ra_fetch_1.Fetcher.api('backend').update('videos', __assign(__assign({}, video.data), { options: options }));
    }
    if (categories.loading || video.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (id && (!video.data.id || channel.id !== video.data.channel_id)) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    if (!id && !video.data.category_id) {
        return react_1.default.createElement(storybook_1.Videos.FormCategories, { categories: categories.data, onChange: function (category_id) { return setVideo({ category_id: category_id }); } });
    }
    function onSubmit() {
        var thumbnailAdded = video.data.thumbnail instanceof File;
        submitVideo().then(function (response) {
            if (response.errors.length) {
                return;
            }
            var modalProps = {
                title: 'De video is succesvol opgeslagen',
                subtitle: thumbnailAdded ? 'Het kan een aantal minuten duren voordat je nieuwe thumbnail wordt weergegeven.' : undefined,
                returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos",
                onClose: function () {
                    closeModal();
                    setChanged(true);
                },
            };
            if (!id) {
                modalProps.onClose = function () {
                    closeModal();
                    setVideo(__assign({}, initModel(user, channel)));
                    setUpload({});
                };
            }
            setModal({
                content: function () { return react_1.default.createElement(storybook_1.Forms.Success, __assign({}, modalProps)); }
            });
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Layouts.ContainerWithSidebar, { className: 'storybook-layouts-space' },
                react_1.default.createElement(storybook_1.Layouts.Main, null,
                    react_1.default.createElement(storybook_1.Videos.FormPlayer, { channel: channel, id: id, video: video.data, setUpload: function (upload) { return setUpload(upload); } }),
                    react_1.default.createElement(storybook_1.Videos.Form, { video: video, setVideo: setVideo, user: user, channel: channel, categories: categories, onSubmit: onSubmit })),
                react_1.default.createElement(storybook_1.Videos.FormSidebar, { toggleVideoOption: toggleVideoOption, user: user, changed: changed, setChanged: setChanged, model: video, setVideo: setVideo, video: video.data, channel: channel })))));
};
exports.Save = Save;
exports.Save.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        permissions: prop_types_1.default.array.isRequired,
    }).isRequired,
    /**
     * Current channel
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        label: prop_types_1.default.string,
    }),
    /**
     * Video ID for editing.
     */
    id: prop_types_1.default.number,
};
exports.Save.defaultProps = {
    id: null,
};
